export default {
  state: {
    isCollapse: false, //导航栏是否折叠
    tabList: [
      {
        path: "/home",
        name: "home",
        // label: '首页',
        // icon: 's-home',
      },
    ], //面包屑的数据:点了哪个路由,首页是一定有的
  },
  mutations: {
    // 修改导航栏展开和收起的方法
    CollapseMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    // 删除tag:删除tabList中对应的item
    closeTag(state, item) {
      // 要删除的是state.tabList中的item
      const index = state.tabList.findIndex((val) => val.name === item.name);
      state.tabList.splice(index, 1);
    },
    // // 设置不同用户的菜单
    // setMenu(state, val) {
    //   state.menu = val;
    //   sessionStorage.setItem("menu", JSON.stringify(val));
    // },
    // // 动态添加路由
    // addMenu(state, router) {
    //   // 判断LocalStorage
    //   if (!sessionStorage.getItem("menu")) return;
    //   const menu = JSON.parse(sessionStorage.getItem("menu"));
    //   state.menu = menu;

    //   const menuArray = [];

    //   // 组装路由
    //   menu.forEach((item) => {
    //     // 判断是否有子路由
    //     if (item.children) {
    //       item.children = item.children.map((itemm) => {
    //         itemm.component = () => import(`@/views/${itemm.component}.vue`);
    //         return itemm;
    //       });
    //       menuArray.push(...item.children);
    //     } else {
    //       item.component = () => import(`@/views/${item.component}.vue`);
    //       menuArray.push(item);
    //     }
    //   });

    //   menuArray.forEach((item) => {
    //     router.addRoute("Main", item);
    //   });
    // },
  },
};
